import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";

import { setupAppPlugins } from "@/plugins/setupAppPlugins";
import { setupMatomo } from "@/plugins/setupMatomo";
import { setupSentry } from "@/plugins/setupSentry";

const app = createApp(App);

setupSentry(app, router);

setupAppPlugins(app, router);
setupMatomo(app, router);

app.mount("#app");

if (window.Cypress) {
  window.app = app;
}
